import type { Editor, TLShape } from 'tldraw'
import type { BoardShapeForHash } from './computeBoardContentHash'

/**
 * Pure projection from tldraw shapes (+ editor for page bounds) into the
 * input shape `computeBoardContentHash` expects (FS-482).
 *
 * Kept separate from `generatePreviewAutomatically` so the text-signature
 * extraction, the null-bounds passthrough, and the new content-prop fields
 * can be unit-tested without spinning up a React tree.
 */
export function buildHashInputsFromEditor(
  editor: Pick<Editor, 'getShapePageBounds'>,
  shapes: TLShape[],
): BoardShapeForHash[] {
  return shapes.map((s) => {
    const bounds = editor.getShapePageBounds(s.id)
    const props = (s.props ?? {}) as Record<string, unknown>
    const textParts: string[] = []
    if (typeof props.text === 'string') textParts.push(props.text)
    if (props.richText && typeof props.richText === 'object') {
      textParts.push(JSON.stringify(props.richText))
    }
    if (typeof props.name === 'string') textParts.push(props.name)
    return {
      id: s.id,
      type: s.type,
      x: s.x,
      y: s.y,
      width: bounds?.w ?? null,
      height: bounds?.h ?? null,
      rotation: s.rotation ?? 0,
      opacity: typeof s.opacity === 'number' ? s.opacity : undefined,
      isLocked: s.isLocked === true ? true : undefined,
      parentId: s.parentId ? String(s.parentId) : undefined,
      index: typeof s.index === 'string' ? s.index : undefined,
      text: textParts.length > 0 ? textParts.join('\x1f') : undefined,
      documentId: (s.meta?.document_id as string | number | null | undefined) ?? undefined,
    }
  })
}
